'use strict';
import { widgetOpeningHoursBuilder } from './builders';
import { CsatContentBuilder } from '../../domain/csat/builders';
var WidgetContactSettingsBuilder = /** @class */ (function () {
    function WidgetContactSettingsBuilder(contact) {
        var defaultContact = {
            id: 'bob-contact-123',
            enabled: true,
            chatSettings: {
                agentAvatarsEnabled: false,
                customFields: [],
                customFieldsEnabled: false,
                emailMandatory: false,
                enabled: false,
                greetingMessage: '',
                greetingMessageEnabled: false,
                issueSelectionEnabled: false,
                openingHours: widgetOpeningHoursBuilder(),
                chatClosedMessageEnabled: false,
                chatClosedMessage: '',
                responseTimeMessageEnabled: false,
                responseTimeMessage: '',
                issueSelections: [],
                subtitle: '',
                subtitleEnabled: false,
                title: '',
                csatEnabled: true,
                csatCustomized: true,
                csatContent: new CsatContentBuilder().build(),
                sendViaEmailEnabled: true,
                multipleActiveChatEnabled: true,
                savedFilterId: null,
                shouldNewMessageReopenClosedChat: true,
                useSchedule: false
            },
            callbackSettings: {
                agentAvatarsEnabled: false,
                customFields: [],
                customFieldsEnabled: false,
                displayWaitTimeEnabled: false,
                enabled: false,
                issueSelectionEnabled: false,
                openingHours: widgetOpeningHoursBuilder(),
                issueSelections: [],
                subtitle: '',
                subtitleEnabled: false,
                title: '',
                ticketDescriptionEnabled: true,
                useSchedule: false
            },
            contactFormSettings: {
                agentAvatarsEnabled: false,
                customFields: [],
                customFieldsEnabled: false,
                enabled: true,
                issueSelectionEnabled: false,
                openingHours: widgetOpeningHoursBuilder(),
                responseTimeMessageEnabled: false,
                responseTimeMessage: '',
                issueSelections: [],
                subtitle: '',
                subtitleEnabled: false,
                title: '',
                ticketDescriptionEnabled: true,
                useSchedule: false
            },
            limitContactExposureEnabled: true
        };
        this.contact = contact || defaultContact;
    }
    WidgetContactSettingsBuilder.prototype.withId = function (id) {
        this.contact.id = id;
        return this;
    };
    WidgetContactSettingsBuilder.prototype.withEnabled = function (enabled) {
        this.contact.enabled = enabled;
        return this;
    };
    WidgetContactSettingsBuilder.prototype.withLimitContactExposureEnabled = function (enabled) {
        this.contact.limitContactExposureEnabled = enabled;
        return this;
    };
    WidgetContactSettingsBuilder.prototype.withChatSettings = function (settings) {
        this.contact.chatSettings = settings;
        return this;
    };
    WidgetContactSettingsBuilder.prototype.withChatEnabled = function (enabled) {
        this.contact.chatSettings.enabled = enabled;
        return this;
    };
    WidgetContactSettingsBuilder.prototype.withCallbackSettings = function (settings) {
        this.contact.callbackSettings = settings;
        return this;
    };
    WidgetContactSettingsBuilder.prototype.withCallbackEnabled = function (enabled) {
        this.contact.callbackSettings.enabled = enabled;
        return this;
    };
    WidgetContactSettingsBuilder.prototype.withContactFormSettings = function (settings) {
        this.contact.contactFormSettings = settings;
        return this;
    };
    WidgetContactSettingsBuilder.prototype.withContactFormEnabled = function (enabled) {
        this.contact.contactFormSettings.enabled = enabled;
        return this;
    };
    WidgetContactSettingsBuilder.prototype.withCsatSettings = function (settings) {
        this.contact.chatSettings.csatContent = settings;
        return this;
    };
    WidgetContactSettingsBuilder.prototype.withCsatSettingsEnabled = function () {
        this.contact.chatSettings.csatEnabled = true;
        return this;
    };
    WidgetContactSettingsBuilder.prototype.withCsatSettingsDisabled = function () {
        this.contact.chatSettings.csatEnabled = false;
        return this;
    };
    WidgetContactSettingsBuilder.prototype.withCsatCustomizedEnabled = function () {
        this.contact.chatSettings.csatCustomized = true;
        return this;
    };
    WidgetContactSettingsBuilder.prototype.withCsatCustomizedDisabled = function () {
        this.contact.chatSettings.csatCustomized = false;
        return this;
    };
    WidgetContactSettingsBuilder.prototype.withCustomizedRatingResponses = function (settings) {
        this.contact.chatSettings.csatContent.customizedRatingResponses = settings;
        return this;
    };
    WidgetContactSettingsBuilder.prototype.build = function () {
        return this.contact;
    };
    return WidgetContactSettingsBuilder;
}());
export { WidgetContactSettingsBuilder };
//# sourceMappingURL=contact-settings-builder.js.map